<template>
  <!-- UX: Legende direkt an der Grafik bzw. im Accordion statt als eigene Karte.
       "inline" zeigt Farbpunkt + Name, die Beschreibung steht im ⓘ. -->
  <ul v-if="items.length" class="mb-type-legend" :class="{ 'mb-type-legend--inline': inline }">
    <li v-for="item in items" :key="item.code" class="mb-type-legend__item">
      <span class="mb-swatch" :class="item.code" aria-hidden="true" />
      <span class="mb-type-legend__name">{{ item.name }}</span>
      <InfoTooltip v-if="inline && describe(item)" :title="item.name" :text="describe(item)" />
      <span v-else-if="describe(item)" class="mb-type-legend__text">{{ describe(item) }}</span>
    </li>
  </ul>
</template>

<script setup>
import InfoTooltip from './InfoTooltip.vue';

const props = defineProps({
  items: { type: Array, default: () => [] },
  inline: { type: Boolean, default: false },
  // UX: Kontextbezogene Beschreibung, z. B. auf der Print-Seite "eigene Titel" statt "eigene Webseiten".
  descriptions: { type: Object, default: null }
});

function describe(item) {
  return (props.descriptions && props.descriptions[item.code]) || item.legend || '';
}
</script>
